import React, { useMemo } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@material-ui/core';
import { imageBasePath } from 'constants';
import styles from './AssignRoleplay.module.scss';
import { CustomButton } from 'shared_ui_components';
import AssignRolePlayLogic from './AssignRoleplayLogic';
import Loading from 'shared_ui_components/Loading';
import AssignRoleplayModalBody from './AssignRoleplayModalBody';
import { useRoleplayStore } from 'features/roleplay/Roleplay.store';

const NewAssignRoleplay = ({
  open = false,
  handleClose = () => null,
  active = false,
  managerOption = false,
  version = false,
}) => {
  const {
    isRep,
    isLoading,
    isLoadingCoach,
    isLoadingAttitudes,
    enabledSubmit,
    handleSubmit,
    onClose,
    isInteractive,
    itHasNoScenarios,
  } = AssignRolePlayLogic({ active, handleClose, managerOption, version });

  const { formDataAssignRoleplay } = useRoleplayStore();

  const isCustom = useMemo(
    () => formDataAssignRoleplay?.roleplay && formDataAssignRoleplay?.roleplay?.value === -1,
    [formDataAssignRoleplay]
  );

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        scroll={'paper'}
        aria-labelledby="add-video-title"
        aria-describedby="add-video-description"
        className={`dialog addVideoDialog ${
          isRep && managerOption && !isInteractive && itHasNoScenarios
            ? styles.dialogForRep
            : styles.dialog
        }`}
      >
        <DialogTitle id="add-video-title">
          <div>{isRep ? 'Create Roleplay' : 'Assign Roleplay'}</div>
          {!isRep && (
            <Typography variant="body2">
              Involve participants being simulated scenarios to practice effective delegation and
              communication skills.
            </Typography>
          )}

          <img
            src={imageBasePath + 'close_gray.svg'}
            alt="close icon"
            className="modalCloseIcon"
            onClick={onClose}
          />
        </DialogTitle>
        <DialogContent>
          {isLoading ? (
            <Loading loading circular margin={100} width="100%" />
          ) : (
            <AssignRoleplayModalBody
              isLoadingCoach={isLoadingCoach}
              isLoadingAttitudes={isLoadingAttitudes}
              isInteractive={isInteractive}
              managerOption={managerOption}
              isRep={isRep}
              itHasNoScenarios={itHasNoScenarios}
            />
          )}
        </DialogContent>
        <DialogActions>
          <CustomButton onClick={onClose} className="tertiaryBtn">
            Cancel
          </CustomButton>
          <CustomButton onClick={handleSubmit} disabled={!(isCustom || enabledSubmit)}>
            {isRep ? 'Start' : 'Assign'} roleplay
          </CustomButton>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default NewAssignRoleplay;
